import React, { useState, useEffect } from "react"
import { Row, Col, Card, CardBody, Input, Button, Table, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import { Link, useHistory } from "react-router-dom"
import ReactPaginate from "react-paginate"
import { URLS } from "../../Url"
import axios from "axios"

function SalesmanList() {
  const GetAuth = localStorage.getItem("authUser")
  const TokenJson = JSON.parse(GetAuth)
  const TokenData = TokenJson.token

  const [Salesmen, setSalesmen] = useState([])
  const [modal_status, setModal_status] = useState(false)
  const [statusReason, setStatusReason] = useState("")
  const [currentSalesmanId, setCurrentSalesmanId] = useState(null)

  useEffect(() => {
    GetSalesmen()
    Pop_up()
  }, [])

  const GetSalesmen = () => {
    const token = TokenData
    axios
      .post(
        URLS.GetSalesman,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setSalesmen(res.data.salesmen || [])
      })
      .catch(err => {
        console.error(err)
        toast.error("Failed to fetch salesmen")
      })
  }

  const [Searchs, setSearchs] = useState({ search: "" })

  const Search = e => {
    let myUser = { ...Searchs }
    myUser[e.target.name] = e.target.value
    setSearchs(myUser)
    const token = TokenData

    axios
      .post(
        URLS.GetSalesmanSearch + `${e.target.value}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setSalesmen(res.data.salesmen || [])
        setPageNumber(0)
      })
      .catch(err => {
        console.error(err)
        toast.error("Search failed")
      })
  }

  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = Salesmen.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(Salesmen.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  // Case‑insensitive active check
  const isSalesmanActive = (salesman) => {
    return salesman.status?.toLowerCase() === "active"
  }

  const updateStatusAPI = (id, newStatus, reason = "") => {
    const token = TokenData
    axios
      .put(
        URLS.UpdateSalesmanStatus,
        {
          id: id,
          status: newStatus,
          inactiveReason: reason,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        if (res.data.success) {
          toast.success(res.data.message)
          GetSalesmen()
          setModal_status(false)
          setStatusReason("")
          setCurrentSalesmanId(null)
        } else {
          toast.error(res.data.message || "Update failed")
        }
      })
      .catch(err => {
        console.error(err)
        toast.error(err.response?.data?.message || "Failed to update status")
      })
  }

  const handleStatusToggle = (data) => {
    const isActive = isSalesmanActive(data)
    if (isActive) {
      setCurrentSalesmanId(data._id)
      setStatusReason(data.inactiveReason || "")
      setModal_status(true)
    } else {
      updateStatusAPI(data._id, "active", "")
    }
  }

  const handleInactiveSubmit = () => {
    if (!statusReason.trim()) {
      toast.warning("Please enter a reason")
      return
    }
    updateStatusAPI(currentSalesmanId, "inactive", statusReason)
  }

  const history = useHistory()

  const EditSalesmanData = data => {
    sessionStorage.setItem("SalesmanData", JSON.stringify(data))
    history.push("/EditSalesman")
  }

  const Pop_up = () => {
    const toastMsg = sessionStorage.getItem("tost")
    if (toastMsg) {
      toast.success(toastMsg)
      sessionStorage.removeItem("tost")
    }
  }

  const DeleteData = data => {
    const confirmBox = window.confirm("Do you really want to Delete?")
    if (confirmBox === true) {
      DeleteSalesmanReq(data)
    }
  }

  const DeleteSalesmanReq = data => {
    const token = TokenData
    const remid = data._id
    axios
      .delete(URLS.DeleteSalesman + remid, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        if (res.status === 200) {
          toast.success(res.data.message)
          GetSalesmen()
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          toast.error(error.response.data.message)
        } else {
          toast.error("Deletion failed")
        }
      })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Bizzmate Supplier" breadcrumbItem="Salesman List" />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <Link to="/AddSalesman">
                        <Button color="primary" size="sm">
                          New Salesman <i className="bx bx-plus-circle"></i>
                        </Button>
                      </Link>
                    </Col>
                    <Col>
                      <div style={{ float: "right" }}>
                        <Input
                          type="search"
                          name="search"
                          value={Searchs.search}
                          onChange={Search}
                          className="form-control"
                          placeholder="Search.."
                          autoComplete="off"
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="table-rep-plugin mt-4 table-responsive">
                    <Table hover bordered responsive>
                      <thead>
                        <tr className="text-center">
                          <th>SlNo</th>
                          <th>Image</th>
                          <th>Name</th>
                          <th>Phone</th>
                          <th>Email</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lists.map((data, key) => {
                          const active = isSalesmanActive(data)
                          return (
                            <tr key={key} className="text-center">
                              <td>{pagesVisited + key + 1}</td>
                              <td>
                                <img
                                  src={URLS.Base + data.image}
                                  height="50px"
                                  width="50px"
                                  className="img-thumbnail"
                                  alt={data.name || "Salesman image"}
                                />
                              </td>
                              <td>{data.name}</td>
                              <td>{data.phone}</td>
                              <td>{data.email}</td>
                              <td>
                                {/* Custom toggle button instead of checkbox */}
                                <Button
                                  color={active ? "success" : "secondary"}
                                  size="sm"
                                  className="px-3 py-1"
                                  onClick={() => handleStatusToggle(data)}
                                  style={{ minWidth: "80px" }}
                                >
                                  {active ? "Active" : "Inactive"}
                                </Button>
                              </td>
                              <td>
                                <i
                                  className="bx bx-edit text-primary me-2"
                                  onClick={() => EditSalesmanData(data)}
                                  style={{ fontSize: "22px", cursor: "pointer" }}
                                ></i>
                                <i
                                  className="bx bx-trash text-danger"
                                  onClick={() => DeleteData(data)}
                                  style={{ fontSize: "22px", cursor: "pointer" }}
                                ></i>
                              </td>
                            </tr>
                          )
                        })}
                        {lists.length === 0 && (
                          <tr>
                            <td colSpan="7" className="text-center">
                              No Salesmen Found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    <div className="d-flex mt-3 mb-1" style={{ float: "right" }}>
                      <ReactPaginate
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        pageCount={pageCount}
                        onPageChange={changePage}
                        containerClassName={"pagination"}
                        previousLinkClassName={"page-link"}
                        nextLinkClassName={"page-link"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        previousClassName={"page-item"}
                        nextClassName={"page-item"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                        breakLabel={"..."}
                        breakClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal
            isOpen={modal_status}
            toggle={() => {
              setModal_status(false)
              setStatusReason("")
            }}
          >
            <ModalHeader
              toggle={() => {
                setModal_status(false)
                setStatusReason("")
              }}
            >
              Change Status to Inactive
            </ModalHeader>
            <ModalBody>
              <FormGroup>
                <Label>Reason *</Label>
                <Input
                  type="textarea"
                  rows="3"
                  value={statusReason}
                  onChange={e => setStatusReason(e.target.value)}
                  placeholder="Enter reason for making inactive"
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                onClick={() => {
                  setModal_status(false)
                  setStatusReason("")
                }}
              >
                Cancel
              </Button>
              <Button color="primary" onClick={handleInactiveSubmit}>
                Confirm
              </Button>
            </ModalFooter>
          </Modal>
          <ToastContainer />
        </div>
      </div>
    </React.Fragment>
  )
}

export default SalesmanList